import React from "react";
import SectionTitle from "./SectionTitle";
import { MarketplaceKeyMetrics } from "./analytics/MarketplaceKeyMetrics";
import { Container, Row } from "react-bootstrap";
import MessagesOverTimeChart from "./analytics/MessagesOverTimeChart";
import InfostealersMessages from "./analytics/InfostealersMessages";
import DataLeaksMessages from "./analytics/DataLeaksMessages";

const CybercrimeSection = ({
  messagesOverTime,
  messageTypes,
  messageTypeColors,
}) => {
  return (
    <div>
      <SectionTitle
        title={"The Underground Market Fueling Cybercrime and Ransomware"}
        question={`Do you know if your data is already exposed?`}
        description={`Lumu infiltrates the underground black markets to identify stolen 
        credentials and data leaks that cybercriminals use to target your company.`}
        end
      />
      <MarketplaceKeyMetrics />
      <Container fluid>
        <Row>
          <MessagesOverTimeChart
            data={messagesOverTime}
            messageTypes={messageTypes}
            messageTypeColors={messageTypeColors}
          />
          <InfostealersMessages />
          <DataLeaksMessages />
        </Row>
      </Container>
    </div>
  );
};

export default CybercrimeSection;
